import React, { useEffect, useState } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Radio from "@mui/material/Radio";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";

import LogoutIcon from "@mui/icons-material/Logout";
import Skeleton from "@mui/material/Skeleton";

import { cnpjMask } from "../../../utils/mask.util";

import RequestService from "../../../services/request.service";
import EnvService from "../../../services/env.service";
import UrlService from "../../../services/url.service";

import useStyles from "./select-account-style";

import { Link } from "react-router-dom";

import { removeCookie } from "../../../utils/cookie.util";
import { ID_COOKIE_BB, ID_COOKIE_GAS } from "../../../constants";
import { getResponseErrorMessage } from "../../../utils/error.util";

const ENDPOINT_LOGIN_PJ_CPF = "login/pj/cpf";
const ENDPOINT_GET_RELATIONSHIPS = "relationships/pj/cpf";

function SkeletonList() {
  return Array.from({ length: 3 }).map((index) => (
    <ListItem key={index}>
      <ListItemIcon>
        <Radio disabled />
      </ListItemIcon>
      <Box width="100%">
        <Skeleton width="80%" height="30px" />
        <Skeleton width="50%" height="20px" />
        <Skeleton width="30%" height="10px" />
      </Box>
    </ListItem>
  ));
}

function SelectRelationship() {
  const [relationships, setRelationships] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [error, setError] = useState();

  const { REACT_APP_GRAFENO_ROUTE_URL } = EnvService.getEnv();
  const redirectAppUrl = UrlService.getQueryString("redirect_app_url");

  useEffect(() => {
    RequestService.get(
      `${REACT_APP_GRAFENO_ROUTE_URL}/${ENDPOINT_GET_RELATIONSHIPS}?redirect_app_url=${redirectAppUrl}`
    )
      .then(({ data: { data: r_relationships } }) =>
        setRelationships(r_relationships)
      )
      .catch((err) => {
        const message = getResponseErrorMessage(err);
        setError(message);
        console.log(err);
      })
      .finally(() => setIsFetching(false));
  }, [REACT_APP_GRAFENO_ROUTE_URL, redirectAppUrl]);

  const handleCallService = async (selectedRelationship) => {
    try {
      await RequestService.post(
        `${REACT_APP_GRAFENO_ROUTE_URL}/${ENDPOINT_LOGIN_PJ_CPF}?redirect_app_url=${redirectAppUrl}`,
        {
          identificacaoUsuario: selectedRelationship.chaveJ,
        }
      );
      window.location = redirectAppUrl;
    } catch (e) {
      const message = getResponseErrorMessage(e);
      setError(message);
      console.error(e);
    }
  };

  function deleteAllCookies() {
    removeCookie(ID_COOKIE_BB);
    removeCookie(ID_COOKIE_GAS);
    setTimeout(() => {
      window.location.href = redirectAppUrl;
    }, 2000);
  }

  const styles = useStyles();
  return (
    <Box>
      <Box className={styles.fullWidth}>
        <Box className={styles.rootHeader}>
          <span
            className={styles.logoArea}
            onClick={() => {
              window.location = "";
            }}
            data-testid="area-click"
          >
            <img
              src="/images/bb-logo.svg"
              className={styles.logo}
              alt="Logo Banco do Brasil"
            />
            <Box component="span" className={styles.logoText}>
              Banco do Brasil
            </Box>
          </span>
          <div
            style={{
              margin: "2px 0 0 10px",
              right: "14px",
              position: "absolute",
            }}
          >
            <button
              className={styles.clearButton}
              onClick={() => deleteAllCookies()}
            >
              <LogoutIcon fontSize="large" />
            </button>
          </div>
        </Box>
      </Box>
      <dls-card style={{ margin: "10px" }}>
        <dls-card-header>
          <Typography variant="h3">
            <b>Relacionamentos</b>
          </Typography>
        </dls-card-header>
        <dls-card-body>
          <Typography variant="h4">
            <b>Pessoa Jurídica</b>
          </Typography>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            {isFetching || error ? (
              <SkeletonList />
            ) : (
              relationships.map((item) => {
                return (
                  <Grid
                    style={{ padding: "10px" }}
                    key={item.chaveJ + item.empresa}
                  >
                    <dls-card>
                      <dls-card-body style={{ margin: "15px 0px 15px 0px" }}>
                        <dls-avatar
                          name={item.empresa}
                          description={"CNPJ: " + cnpjMask(item.cnpj)}
                          noBorder=""
                        />
                      </dls-card-body>
                      <dls-card-footer style={{ width: "100%" }}>
                        {item.empresaAutorizada ? (
                          <div style={{ width: "100%" }}>
                            <dls-button
                              size="small"
                              fullwidth
                              color="primary"
                              onClick={() => handleCallService(item)}
                              style={{ fontFamily: 'BancoDoBrasilTitulos-Bold' }}
                            >
                              Acessar
                            </dls-button>
                          </div>
                        ) : (
                          <div style={{ width: "100%" }}>
                            <Link
                              to={{
                                pathname: "register-pc",
                                state: item,
                              }}
                            >
                              <dls-button
                                size="small"
                                fullwidth
                                color="secondary"
                                style={{ width: "100%", fontFamily: 'BancoDoBrasilTitulos-Bold' }}
                              >
                                Liberar Equipamento
                              </dls-button>
                            </Link>
                          </div>
                        )}
                      </dls-card-footer>
                    </dls-card>
                  </Grid>
                );
              })
            )}
          </Grid>
        </dls-card-body>
      </dls-card>
    </Box>
  );
}

export default SelectRelationship;
